/**
 * The whole manual on one page (/help). ?c=<chapter> scrolls to a chapter;
 * ?print=1 is the print layout scripts/help/print.ts turns into the PDF.
 */
import { useEffect } from "react";
import { ChapterBody, MANUAL_PDF, useManual } from "../components/Help";

export function HelpPage() {
  const chapters = useManual();
  const params = new URLSearchParams(location.search);
  const print = params.get("print") === "1";
  useEffect(() => {
    document.body.classList.toggle("help-print", print);
    const c = params.get("c");
    if (c) setTimeout(() => document.getElementById(`chapter-${c}`)?.scrollIntoView({ block: "start" }), 50);
    return () => document.body.classList.remove("help-print");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <main className="page help-page">
      <header className="block-head help-head">
        <div>
          <h1>Agora manual</h1>
          <p className="muted-text">How Agora works, page by page. Press ? anywhere to open the chapter for the page you are on.</p>
        </div>
        <div className="actions no-print">
          <a className="btn ghost small" href={MANUAL_PDF} target="_blank" rel="noreferrer">
            PDF
          </a>
          <button className="btn primary small" type="button" onClick={() => window.print()}>
            Print
          </button>
        </div>
      </header>
      <nav className="help-toc" aria-label="Chapters">
        <ol>
          {chapters.map((c) => (
            <li key={c.id}>
              <a href={`#chapter-${c.id}`}>{c.title}</a> <span className="muted-text">{c.summary}</span>
            </li>
          ))}
        </ol>
      </nav>
      {chapters.map((c) => (
        <article key={c.id} id={`chapter-${c.id}`} className="card-block help-article">
          <ChapterBody chapter={c} />
        </article>
      ))}
    </main>
  );
}
